export default {
    data() {
        return {
            wwidth: window.$(window).width()
        }
    },
    computed: {
        isMobile() {
            return this.wwidth < 768
        }
    },
    created() {
        window.addEventListener('resize', this.resizeHandler)
    },
    destroyed() {
        window.removeEventListener('resize', this.resizeHandler)
    },
    methods: {
        resizeHandler() {
            if (window.$(window).width() == this.wwidth) return
            this.wwidth = window.$(window).width()
        }
    }
}
